export const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Docs', to: '/docs' },
];

export const PLATFORMS = ['iOS', 'Android', 'Desktop', 'Web'];
